import { useNavigate } from "react-router-dom";
import { NAV_LINKS } from "../data";
import { IconInstagram, IconFacebook, IconMail, IconMapPin } from "./icons";
import butterflyLogo from "../assets/images/logo/butterfly-logo.svg";

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer style={{
      background: "var(--night)", color: "rgba(255,255,255,0.6)",
      padding: "60px 0 32px", position: "relative",
    }}>
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, height: "1px",
        background: "linear-gradient(90deg, transparent, var(--gold), transparent)",
      }} />
      <div className="sb-container">
        <div style={{
          display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "40px", marginBottom: "48px",
        }}>
          {/* Brand */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" }}>
              <span style={{ fontFamily: "var(--font-display)", fontWeight: 700, fontSize: "1.15rem", color: "var(--gold)" }}>
                Silly Butterfly
              </span>
              <img src={butterflyLogo} alt="Silly Butterfly logo" style={{ width: "1.6rem", height: "1.6rem", objectFit: "contain" }} />
            </div>
            <p style={{ fontSize: "0.88rem", lineHeight: 1.7, maxWidth: "280px" }}>
              We provide cocktail making classes and cocktail services for private settings.
            </p>
            <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
              <a href="https://www.instagram.com/sillybutterflycocktails/" style={{ color: "var(--gold)", opacity: 0.7, transition: "opacity 0.3s" }} onMouseEnter={e => e.target.style.opacity = 1} onMouseLeave={e => e.target.style.opacity = 0.7} aria-label="Visit Silly Butterfly on Instagram"><IconInstagram /></a>
              <a href="https://www.facebook.com/share/1UfsqG8wRo/?mibextid=wwXlfr" style={{ color: "var(--gold)", opacity: 0.7, transition: "opacity 0.3s" }} onMouseEnter={e => e.target.style.opacity = 1} onMouseLeave={e => e.target.style.opacity = 0.7} aria-label="Visit Silly Butterfly on Facebook"><IconFacebook /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontFamily: "var(--font-body)", fontWeight: 600, fontSize: "0.9rem", color: "var(--gold)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "18px" }}>Explore</h4>
            {NAV_LINKS.map(({ label, path }) => (
              <button
                key={path}
                onClick={() => { navigate(path); window.scrollTo({ top: 0 }); }}
                style={{
                  display: "block", background: "none", border: "none", cursor: "pointer",
                  color: "rgba(255,255,255,0.6)", fontFamily: "var(--font-body)", fontSize: "0.9rem",
                  padding: "5px 0", transition: "color 0.3s",
                }}
                onMouseEnter={e => e.target.style.color = "var(--gold)"}
                onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.6)"}
              >
                {label}
              </button>
            ))}
            <button
              onClick={() => { navigate("/quote"); window.scrollTo({ top: 0 }); }}
              style={{
                display: "block", background: "none", border: "none", cursor: "pointer",
                color: "rgba(255,255,255,0.6)", fontFamily: "var(--font-body)", fontSize: "0.9rem",
                padding: "5px 0", transition: "color 0.3s",
              }}
              onMouseEnter={e => e.target.style.color = "var(--gold)"}
              onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.6)"}
            >
              Get a Quote
            </button>
            <button
              onClick={() => { navigate("/leave-review"); window.scrollTo({ top: 0 }); }}
              style={{
                display: "block", background: "none", border: "none", cursor: "pointer",
                color: "rgba(255,255,255,0.6)", fontFamily: "var(--font-body)", fontSize: "0.9rem",
                padding: "5px 0", transition: "color 0.3s",
              }}
              onMouseEnter={e => e.target.style.color = "var(--gold)"}
              onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.6)"}
            >
              Leave a Review
            </button>
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: "var(--font-body)", fontWeight: 600, fontSize: "0.9rem", color: "var(--gold)", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "18px" }}>Get in Touch</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", fontSize: "0.9rem" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}><span style={{ color: "var(--gold)" }}><IconMail /></span> hello@sillybutterfly.com</div>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}><span style={{ color: "var(--gold)" }}><IconMapPin /></span> We come to you — subject to availability</div>
            </div>
          </div>
        </div>

        <div style={{
          borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: "24px",
          display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center",
          gap: "12px", fontSize: "0.8rem",
        }}>
          <span>© {new Date().getFullYear()} Silly Butterfly. All rights reserved.</span>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", alignItems: "center" }}>
            {[
              { label: "Terms & Conditions", path: "/terms" },
              { label: "Privacy Policy", path: "/privacy" },
              { label: "Cookies Policy", path: "/cookies" },
            ].map(({ label, path }) => (
              <button
                key={path}
                onClick={() => { navigate(path); window.scrollTo({ top: 0 }); }}
                style={{
                  background: "none", border: "none", cursor: "pointer", padding: 0,
                  color: "rgba(255,255,255,0.4)", fontFamily: "var(--font-body)", fontSize: "0.8rem",
                  transition: "color 0.3s",
                }}
                onMouseEnter={e => e.target.style.color = "var(--gold)"}
                onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.4)"}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
